import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, Check } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/aSzFRmhQMwh8e9CwHWzxqy/producto_3_am.png';
export function CTASection() {
  return <Section background="light" className="text-center" data-id="element-19">
      <div id="comprar" className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-slate-100 max-w-3xl mx-auto" data-id="element-20">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-21">
          {/* Product image */}
          <div className="flex-shrink-0 w-44 sm:w-52" data-id="element-22">
            <img src={PRODUCT_IMAGE} alt="3AM RESET" className="w-full h-auto rounded-xl shadow-lg" data-id="element-23" />
          </div>

          {/* CTA content */}
          <div className="flex-1 text-center md:text-left" data-id="element-24">
            <h2 className="text-3xl font-serif font-bold text-slate-900 mb-2" data-id="element-25">
              Empieza esta noche
            </h2>
            <p className="text-slate-600 mb-4" data-id="element-26">
              Si hoy te está pasando, no esperes a "estar peor" para tomarlo en
              serio.
            </p>

            {/* Price */}
            <div className="mb-6" data-id="element-27">
              <div className="flex items-baseline gap-3 flex-wrap" data-id="element-28">
                <span className="text-lg text-slate-400 line-through" data-id="element-29">
                  $19.99
                </span>
                <span className="text-4xl font-bold text-slate-900" data-id="element-30">$6.36</span>
                <span className="text-lg text-slate-500" data-id="element-31">USD</span>
                <span className="bg-amber-100 text-amber-700 text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-32">
                  -68% desc.
                </span>
              </div>
              <p className="text-xs text-slate-400 mt-1" data-id="element-33">
                Acceso inmediato al PDF
              </p>
            </div>

            <a href="https://www.factoravance.com/cart/51526784745792:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 px-10 py-4 text-lg w-full sm:w-auto bg-amber-600 text-white hover:bg-amber-700 shadow-lg hover:shadow-xl hover:-translate-y-0.5 shadow-amber-500/20" data-id="element-34">
              Quiero 3AM RESET <ArrowRight className="ml-2 w-5 h-5" data-id="element-35" />
            </a>

            <ul className="mt-6 space-y-2 text-sm text-slate-500 text-left" data-id="element-36">
              {['El buró listo', 'El celular fuera', 'La Tarjeta 3AM a la mano', 'Un plan que no depende de suerte'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-37">
                  <Check className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-38" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}